const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID?.trim();
const GA_ID = process.env.REACT_APP_GA_ID?.trim();

let initialized = false;

function initMetaPixel() {
  if (!META_PIXEL_ID || window.fbq) return;

  window.fbq = function () {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments);
  };
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = "2.0";
  window.fbq.queue = [];
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

function initGA4() {
  if (!GA_ID || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);
}

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  initMetaPixel();
  initGA4();

  // Todo clic en un enlace de WhatsApp cuenta como conversión
  document.addEventListener("click", (e) => {
    const anchor = e.target.closest?.('a[href^="https://wa.me/"]');
    if (anchor) {
      trackWhatsAppClick({ content_name: anchor.dataset.testid || "whatsapp_cta" });
    }
  });
}

export function trackLeadFormSubmit(parameters = {}) {
  if (window.fbq && META_PIXEL_ID) {
    window.fbq("track", "Lead", parameters);
  }
  if (window.gtag && GA_ID) {
    window.gtag("event", "generate_lead", parameters);
  }
}

export function trackWhatsAppClick(parameters = {}) {
  if (window.fbq && META_PIXEL_ID) {
    window.fbq("track", "Contact", parameters);
  }
  if (window.gtag && GA_ID) {
    window.gtag("event", "contact", parameters);
  }
}
